export default "__VITE_PUBLIC_ASSET__699b6f4b__"